export default "__VITE_ASSET__OVdYAWYB__"